import { HTMLReactParserOptions } from 'html-react-parser'
import type { JSX } from 'react'
// import { Element, HTMLReactParserOptions } from 'html-react-parser'
// import { nodeParser } from './node-parsers'

export interface NodeParser {
  (node: Element, additionalMacros?: object, additionalNodeParsers?: NodeParser[]):
    | false
    | void
    | object
    | JSX.Element
    | null
    | undefined
}

export const nodeParserOptions: HTMLReactParserOptions = {
  // htmlparser2 options are not used client side. See https://github.com/remarkablemark/html-react-parser#htmlparser2
  // set lowerCaseAttributeNames to avoid bug (?) in library: https://github.com/remarkablemark/html-react-parser/issues/233
  // TODO: We should probably think about how to render the umbraco markup ssr & rehydrate without macro parsing
  trim: true,
  htmlparser2: {
    decodeEntities: true,
    lowerCaseAttributeNames: true,
    xmlMode: false,
    lowerCaseTags: true,
    recognizeSelfClosing: true,
  },
  //   replace: domnode => nodeParser(domnode as Element) ?? domnode,
}
